import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./Toolbar.css";

// Normalize values to show "TBD" when empty/null/etc.
// const normalizeValue = (v) => {
//   if (v === null || v === undefined) return "TBD";
//   if (typeof v === "string") return v.trim() === "" ? "TBD" : v;
//   return v;
// };

// Apply italic + opacity when value is TBD
const getTextStyle = () => ({
  fontStyle: "normal",
  opacity: 1,
});

const fieldLabels = {
  itemId: "Item",
  siteCode: "Site Code",
  lob: "LOB",
  currencyTo: "Currency To"
};

const Toolbar = ({
  number,
  status,
  icon,
  onBack,
  isCollapsed,
  toggleHeader,
  toolbarMeta,
  hideExpandButton = false
}) => {
  return (
    <div className="toolbar">
      <div className="toolbar-left">
        {/* Back Button */}
        <ChevronLeftIcon
          onClick={onBack}
          className="back-icon"
          role="button"
          aria-label="Go Back"
        />

        {/* Inventory Icon */}
        {icon && (
          <span className="toolbar-icon" style={{ marginLeft: 4 }}>
            {icon}
          </span>
        )}

        {toolbarMeta && (
          <div className="toolbar-heading" style={{ marginLeft: 4 }}>
            {/* Item Name */}
            <div className="toolbar-title-row">
              <div
                className="item-name"
                style={getTextStyle()}
              >
                {toolbarMeta?.heading || ""}
              </div>
            </div>

            {/* Meta Line */}
            <div className="meta-line">
              {toolbarMeta?.metaLine &&
                Object.entries(toolbarMeta.metaLine).map(([key, value], index, arr) => (
                  <span key={key} style={getTextStyle()}>
                    {`${fieldLabels[key]} : ${value || ""}`}
                    {arr.length > 1 && index < arr.length - 1 && " | "}
                  </span>
                ))}
            </div>
          </div>
        )}

        {/* Number */}
        <span className="toolbar-number" style={{ marginLeft: 4 }}>
          {number}
        </span>

        {/* Status Badge */}
        {status && (
          <span
            className={status.length > 1 ? `status-badge ${status.split(' ').join('-').toLowerCase()}`
              : `status-badge ${status.toLowerCase()}`}
            style={{ marginLeft: 8 }}
          >
            {status}
          </span>
        )}
      </div>

      {/* Collapse/Expand Button */}
      {!hideExpandButton && <div className="toolbar-right">
        <button
          className="collapse-toggle-button"
          onClick={toggleHeader}
          aria-label="Toggle Collapse"
        >
          {isCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </button>
      </div>}
    </div>
  );
};

export default Toolbar;
